import cn from 'classnames';
import React from 'react';
import {useSelector} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import BackButton from '../../../../components/BackButton/BackButton';
import DualLayout from '../../../../components/DataDisplay/DualLayout';
import Container from '../../../../components/Layout/Container/Container';
import useDeviceTypeStyles from '../../../../hooks/useDeviceTypeStyles';
import {getLocalizedStrings} from '../../../../services/localization/localizationService';
import {makeSelectIotDeviceFullData} from '../../../../state/selectors/consumer';
import PairingGuideVideo from '../../../PairingGuidePage/components/PairingGuideVideo/PairingGuideVideo';
import SignedImage from '../../../System/SignedImage';
import reconnectDeviceGuidePopupService from '../reconnectDeviceGuidePopupService';

const selector = createStructuredSelector({
    iotDevice: makeSelectIotDeviceFullData(),
});

const ReconnectGuideComponent = (props) => {
    const {guideData, hideModalGuide} = props;
    const {header, reconnectStepList, video, videoStartTime, videoStopTime, thumbnail} = guideData;
    const localizedStrings = getLocalizedStrings();
    const {iotDevice} = useSelector(selector);
    const {device} = iotDevice;
    const {type: deviceType} = device || {};
    const {mediaData, defaultImage} = reconnectDeviceGuidePopupService.getImageData(deviceType);
    const isVideoContainer = !!video;
    const description = reconnectStepList?.map((step) => localizedStrings[step]);
    const backgroundColor = useDeviceTypeStyles(deviceType);

    return (
        <>
            <Container isFloatHeight className='min-h-[48px] w-full lg:top-[90px]'>
                <BackButton
                    onClick={hideModalGuide}
                    className='absolute left-8 top-[50%] -translate-y-1/2 rtl:left-[unset] rtl:right-8'
                />
            </Container>
            <DualLayout
                className='mb-10 lg:mb-0 lg:py-36'
                classNameRight='overflow-hidden flex items-center'
                articleProps={{
                    titleKey: header,
                    titleClassName: 'mb-3 md:mt-0 md:mb-4',
                    descriptionText: description?.join(' '),
                }}
            >
                {isVideoContainer ? (
                    <div className={cn('z-0 h-[212px] w-full md:h-[356px] lg:h-[456px]', backgroundColor)}>
                        <PairingGuideVideo
                            content={[{videoStartTime, videoStopTime}]}
                            index={0}
                            src={video}
                            thumbnailSrc={thumbnail}
                        />
                    </div>
                ) : (
                    <SignedImage
                        imgClassName={'w-full'}
                        defaultImage={defaultImage}
                        isThumbnailAvailable
                        mediaData={mediaData}
                        signIfNull
                    />
                )}
            </DualLayout>
        </>
    );
};

export default ReconnectGuideComponent;
